var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater2020(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_4581)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 584,
    fill: "url(#paint0_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 319.5C14.9281 314.19 -95.7287 349.371 -161 375L-187 435.152L-133.345 749.5H1521.67C1554.86 706.17 1584.65 322.598 1505 319.5C1405.43 315.628 1297.65 398.644 1154.38 398.644C1011.12 398.644 992.427 354.256 873.5 362C754.573 369.744 761.647 401.41 607.872 398.644C454.097 395.878 264.84 326.138 126 319.5Z",
    fill: "url(#paint1_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.033 492.709C472.438 496.706 472.2 509.142 469.342 509.142C466.484 509.142 466.365 498.631 465.651 492.709C464.936 486.787 460.74 476.275 469.342 476.275C477.944 476.275 473.628 488.712 473.033 492.709Z",
    fill: "url(#paint2_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.32,
    cy: 471.783,
    rx: 2.95566,
    ry: 3.78325,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.608 492.709C965.203 496.706 965.441 509.142 968.299 509.142C971.157 509.142 971.276 498.631 971.99 492.709C972.704 486.787 976.901 476.275 968.299 476.275C959.697 476.275 964.012 488.712 964.608 492.709Z",
    fill: "url(#paint3_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.95566,
    cy: 3.78325,
    rx: 2.95566,
    ry: 3.78325,
    transform: "matrix(-1 0 0 1 971.276 468)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.033 486.709C450.438 490.706 450.2 503.142 447.342 503.142C444.484 503.142 444.365 492.631 443.651 486.709C442.936 480.787 438.74 470.275 447.342 470.275C455.944 470.275 451.628 482.712 451.033 486.709Z",
    fill: "url(#paint4_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.32,
    cy: 465.783,
    rx: 2.95566,
    ry: 3.78325,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M986.608 486.709C987.203 490.706 987.441 503.142 990.299 503.142C993.157 503.142 993.276 492.631 993.99 486.709C994.704 480.787 998.901 470.275 990.299 470.275C981.697 470.275 986.012 482.712 986.608 486.709Z",
    fill: "url(#paint5_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.95566,
    cy: 3.78325,
    rx: 2.95566,
    ry: 3.78325,
    transform: "matrix(-1 0 0 1 993.276 462)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.033 490.709C433.438 494.706 433.2 507.142 430.342 507.142C427.484 507.142 427.365 496.631 426.651 490.709C425.936 484.787 421.74 474.275 430.342 474.275C438.944 474.275 434.628 486.712 434.033 490.709Z",
    fill: "url(#paint6_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 430.32,
    cy: 469.783,
    rx: 2.95566,
    ry: 3.78325,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1003.61 490.709C1004.2 494.706 1004.44 507.142 1007.3 507.142C1010.16 507.142 1010.28 496.631 1010.99 490.709C1011.7 484.787 1015.9 474.275 1007.3 474.275C998.697 474.275 1003.01 486.712 1003.61 490.709Z",
    fill: "url(#paint7_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.95566,
    cy: 3.78325,
    rx: 2.95566,
    ry: 3.78325,
    transform: "matrix(-1 0 0 1 1010.28 466)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.033 484.709C412.438 488.706 412.2 501.142 409.342 501.142C406.484 501.142 406.365 490.631 405.651 484.709C404.936 478.787 400.74 468.275 409.342 468.275C417.944 468.275 413.628 480.712 413.033 484.709Z",
    fill: "url(#paint8_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.32,
    cy: 463.783,
    rx: 2.95566,
    ry: 3.78325,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024.61 484.709C1025.2 488.706 1025.44 501.142 1028.3 501.142C1031.16 501.142 1031.28 490.631 1031.99 484.709C1032.7 478.787 1036.9 468.275 1028.3 468.275C1019.7 468.275 1024.01 480.712 1024.61 484.709Z",
    fill: "url(#paint9_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.95566,
    cy: 3.78325,
    rx: 2.95566,
    ry: 3.78325,
    transform: "matrix(-1 0 0 1 1031.28 460)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.033 487.709C392.438 491.706 392.2 504.142 389.342 504.142C386.484 504.142 386.365 493.631 385.651 487.709C384.936 481.787 380.74 471.275 389.342 471.275C397.944 471.275 393.628 483.712 393.033 487.709Z",
    fill: "url(#paint10_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.32,
    cy: 466.783,
    rx: 2.95566,
    ry: 3.78325,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044.61 487.709C1045.2 491.706 1045.44 504.142 1048.3 504.142C1051.16 504.142 1051.28 493.631 1051.99 487.709C1052.7 481.787 1056.9 471.275 1048.3 471.275C1039.7 471.275 1044.01 483.712 1044.61 487.709Z",
    fill: "url(#paint11_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.95566,
    cy: 3.78325,
    rx: 2.95566,
    ry: 3.78325,
    transform: "matrix(-1 0 0 1 1051.28 463)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.568 470.063C663.548 447.593 657.067 438.765 653.606 436.297C651.728 436.208 651.12 438.649 651.919 439.873C660.353 452.797 663.038 462.13 664.624 470.926C665.08 473.457 667.946 472.616 667.568 470.063Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.148 471.063C629.168 448.593 635.649 439.765 639.11 437.297C640.988 437.208 641.596 439.649 640.797 440.873C632.363 453.797 629.678 463.13 628.092 471.926C627.636 474.457 624.77 473.616 625.148 471.063Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.552 467.963C653.324 476.208 652.833 501.858 646.938 501.858C641.044 501.858 640.799 480.178 639.325 467.963C637.852 455.749 629.197 434.069 646.938 434.069C664.68 434.069 655.78 459.719 654.552 467.963Z",
    fill: "url(#paint12_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 646.894,
    cy: 424.803,
    rx: 6.09606,
    ry: 7.80296,
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.97 475.857C619.05 475.857 617.107 477.566 617 478.42C617.256 479.445 620.31 487.603 621.164 491.554C621.164 491.554 623.407 492.195 625.97 492.195C628.532 492.195 630.775 491.554 630.775 491.554L634.619 478.42C634.619 477.566 632.889 475.857 625.97 475.857Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.97 475.857C659.05 475.857 657.107 477.566 657 478.42C657.256 479.445 660.31 487.603 661.164 491.554C661.164 491.554 663.407 492.195 665.97 492.195C668.532 492.195 670.775 491.554 670.775 491.554L674.619 478.42C674.619 477.566 672.889 475.857 665.97 475.857Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 625.969,
    cy: 478.42,
    rx: 8.00855,
    ry: 1.92205,
    fill: "url(#paint13_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 665.969,
    cy: 478.42,
    rx: 8.00855,
    ry: 1.92205,
    fill: "url(#paint14_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.908 452.485L827.095 467.156C827.095 467.156 826.438 468.689 827.857 469.552C829.277 470.416 830.363 469.341 830.363 469.341C830.363 469.341 842.776 453.503 842.359 451.4C841.941 449.296 824.709 437.857 824.709 437.857L822.433 442.808L836.908 452.485Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.89 479.043C799.049 452.771 804.239 441.278 807.548 437.67C809.643 437.122 810.911 439.726 810.304 441.296C803.891 457.869 803.097 469.025 803.412 479.311C803.503 482.271 800.074 482.009 799.89 479.043Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.151 473.971C808.565 483.465 809.13 513 815.918 513C822.705 513 822.988 488.036 824.684 473.971C826.381 459.906 836.347 434.941 815.918 434.941C795.488 434.941 805.737 464.477 807.151 473.971Z",
    fill: "url(#paint15_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.0197,
    cy: 8.98522,
    rx: 7.0197,
    ry: 8.98522,
    transform: "matrix(-1 0 0 1 822.988 415.286)",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.031 457C829.999 457 832.236 458.967 832.359 459.951C832.064 461.131 828.548 470.526 827.564 475.075C827.564 475.075 824.982 475.813 822.031 475.813C819.08 475.813 816.498 475.075 816.498 475.075L812.071 459.951C812.071 458.967 814.063 457 822.031 457Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.22196,
    cy: 2.21327,
    rx: 9.22196,
    ry: 2.21327,
    transform: "matrix(-1 0 0 1 831.252 457.738)",
    fill: "url(#paint16_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.426 477.415L520.548 485.073C520.548 485.073 520.891 485.873 520.15 486.323C519.409 486.774 518.843 486.213 518.843 486.213C518.843 486.213 512.364 477.947 512.581 476.849C512.799 475.751 521.793 469.78 521.793 469.78L522.981 472.365L515.426 477.415Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.747 491.277C535.186 477.564 532.477 471.566 530.75 469.683C529.657 469.396 528.995 470.756 529.312 471.575C532.659 480.225 533.073 486.048 532.909 491.417C532.861 492.962 534.651 492.825 534.747 491.277Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.192 479.771C519.033 479.771 517.865 480.798 517.801 481.312C517.955 481.928 519.79 486.831 520.304 489.205C520.304 489.205 521.651 489.591 523.192 489.591C524.732 489.591 526.08 489.205 526.08 489.205L528.39 481.312C528.39 480.798 527.35 479.771 523.192 479.771Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 523.191,
    cy: 481.312,
    rx: 4.81326,
    ry: 1.15518,
    fill: "url(#paint17_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.957 488.63C530.219 493.585 529.924 509 526.381 509C522.839 509 522.691 495.97 521.806 488.63C520.92 481.289 515.718 468.259 526.381 468.259C537.045 468.259 531.695 483.675 530.957 488.63Z",
    fill: "url(#paint18_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 526.355,
    cy: 462.69,
    rx: 3.66382,
    ry: 4.68969,
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M904.064 473.778L898.352 482.317C898.352 482.317 897.97 483.21 898.796 483.712C899.622 484.215 900.254 483.589 900.254 483.589C900.254 483.589 907.479 474.371 907.236 473.147C906.993 471.922 896.963 465.264 896.963 465.264L895.639 468.146L904.064 473.778Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.518 489.236C882.028 473.944 885.05 467.255 886.976 465.155C888.195 464.836 888.933 466.352 888.579 467.265C884.847 476.912 884.385 483.405 884.568 489.392C884.621 491.115 882.625 490.962 882.518 489.236Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.404 476.406C900.042 476.406 901.344 477.551 901.416 478.124C901.244 478.811 899.197 484.279 898.625 486.927C898.625 486.927 897.122 487.356 895.404 487.356C893.687 487.356 892.184 486.927 892.184 486.927L889.607 478.124C889.607 477.551 890.767 476.406 895.404 476.406Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.3676,
    cy: 1.28822,
    rx: 5.3676,
    ry: 1.28822,
    transform: "matrix(-1 0 0 1 900.772 476.836)",
    fill: "url(#paint19_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.743 486.284C887.567 491.81 887.896 509.001 891.846 509.001C895.797 509.001 895.961 494.471 896.949 486.284C897.936 478.098 903.737 463.567 891.846 463.567C879.955 463.567 885.92 480.758 886.743 486.284Z",
    fill: "url(#paint20_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.08579,
    cy: 5.22981,
    rx: 4.08579,
    ry: 5.22981,
    transform: "matrix(-1 0 0 1 895.962 452.127)",
    fill: "#F5B370"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.818 460.31L575.498 453.23C575.498 453.23 574.755 452.411 575.459 451.563C576.162 450.715 577.075 451.154 577.075 451.154C577.075 451.154 588.278 458.405 588.47 459.814C588.663 461.223 580.328 472.116 580.328 472.116L577.832 469.502L584.818 460.31Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.59 497.078C562.033 479.656 565.474 472.035 567.669 469.643C569.058 469.279 569.899 471.006 569.496 472.047C565.243 483.037 564.717 490.434 564.926 497.256C564.986 499.218 562.712 499.044 562.59 497.078Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.405 493.714C568.343 500.01 568.718 519.596 573.219 519.596C577.72 519.596 577.907 503.041 579.032 493.714C580.157 484.388 586.766 467.833 573.219 467.833C559.671 467.833 566.468 487.419 567.405 493.714Z",
    fill: "url(#paint21_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.65492,
    cy: 5.9583,
    rx: 4.65492,
    ry: 5.9583,
    transform: "matrix(-1 0 0 1 577.907 454.8)",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.292 444C578.576 444 580.06 445.305 580.142 445.957C579.946 446.74 577.614 452.969 576.962 455.986C576.962 455.986 575.249 456.475 573.292 456.475C571.336 456.475 569.623 455.986 569.623 455.986L566.688 445.957C566.688 445.305 568.009 444 573.292 444Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.11529,
    cy: 1.46767,
    rx: 6.11529,
    ry: 1.46767,
    transform: "matrix(-1 0 0 1 579.408 444.489)",
    fill: "url(#paint22_radial_497_4581)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1433.27 156.522H1472.77C1472.77 112.522 1468.97 26.5216 1453.77 34.5216C1434.77 44.5216 1433.27 47.0216 1410.27 46.0216C1387.27 45.0216 1395.27 62.0216 1390.27 56.0216C1385.27 50.0216 1372.27 57.0216 1350.77 62.0216C1329.27 67.0216 1331.77 71.0216 1310.77 78.0216C1289.77 85.0216 1283.27 83.0216 1268.77 83.0216H1238.27C1232.77 83.0216 1225.27 78.0216 1207.77 83.0216C1190.27 88.0216 1197.77 93.0216 1197.27 99.0216C1196.77 105.022 1185.77 111.022 1174.77 111.022C1163.77 111.022 1128.77 110.522 1110.77 111.022C1092.77 111.522 1090.77 121.022 1085.27 124.522C1079.77 128.022 1067.27 128.522 1030.77 133.522C994.269 138.522 1025.77 148.022 1030.77 148.022H1076.27C1106.27 148.022 1106.77 141.522 1116.27 133.522C1125.77 125.522 1133.77 133.522 1147.77 133.522C1161.77 133.522 1160.27 141.522 1165.77 148.022C1171.27 154.522 1191.27 141.522 1225.27 141.522C1259.27 141.522 1241.27 128.522 1276.27 128.522C1311.27 128.522 1365.77 122.522 1346.77 133.522C1327.77 144.522 1350.27 148.022 1372.27 141.522C1394.27 135.022 1388.77 142.522 1401.77 148.022C1414.77 153.522 1423.27 156.522 1433.27 156.522Z",
    fill: "url(#paint23_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.769 227.299H328.269C329.936 226.299 334.369 224.899 338.769 227.299C344.269 230.299 363.269 222.799 404.769 216.799C437.969 211.999 393.602 205.799 367.269 203.299C364.602 201.633 357.869 198.299 352.269 198.299C345.269 198.299 328.269 204.299 311.769 203.299C298.569 202.499 296.602 199.633 297.269 198.299H268.769H234.769C219.269 198.299 218.269 189.299 209.769 171.299C210.769 160.799 187.269 165.299 178.769 165.299C170.269 165.299 156.269 173.799 143.769 181.799C131.269 189.799 137.769 182.799 120.269 181.799C106.269 180.999 109.102 170.466 112.269 165.299C109.436 165.299 102.169 163.699 95.769 157.299C87.769 149.299 57.269 152.65 45.269 152.65C33.269 152.65 40.769 144.65 45.269 138.15C49.769 131.65 28.769 133.15 21.269 133.15C15.269 133.15 2.43561 140.816 -3.23105 144.65C-6.06439 159.65 -12.131 205.199 -13.731 216.799C-15.731 231.299 -6.23105 227.299 3.76895 227.299H47.269C64.769 227.299 68.769 227.299 83.269 236.299C97.769 245.299 132.769 227.299 143.769 227.299H187.269C209.769 227.299 203.769 227.299 218.269 236.299C232.769 245.299 251.269 227.299 268.769 227.299Z",
    fill: "url(#paint24_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 428,
    width: 72,
    height: 49,
    fill: "url(#paint25_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 435,
    width: 72,
    height: 42,
    fill: "url(#paint26_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 438,
    width: 66,
    height: 67,
    fill: "url(#paint27_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 450,
    width: 66,
    height: 67,
    fill: "url(#paint28_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 428,
    width: 66,
    height: 77,
    fill: "url(#paint29_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 438,
    width: 23,
    height: 31,
    fill: "url(#paint30_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 446,
    width: 23,
    height: 31,
    fill: "url(#paint31_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 441,
    width: 23,
    height: 40,
    fill: "url(#paint32_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 462,
    width: 23,
    height: 28,
    fill: "url(#paint33_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 446,
    width: 23,
    height: 23,
    fill: "url(#paint34_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 49,
    transform: "matrix(-1 0 0 1 1360 440)",
    fill: "url(#paint35_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 42,
    transform: "matrix(-1 0 0 1 1440 447)",
    fill: "url(#paint36_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 67,
    transform: "matrix(-1 0 0 1 1280 450)",
    fill: "url(#paint37_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 67,
    transform: "matrix(-1 0 0 1 1132 454)",
    fill: "url(#paint38_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 77,
    transform: "matrix(-1 0 0 1 1206 440)",
    fill: "url(#paint39_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 31,
    transform: "matrix(-1 0 0 1 1336 450)",
    fill: "url(#paint40_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 31,
    transform: "matrix(-1 0 0 1 1258 458)",
    fill: "url(#paint41_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 40,
    transform: "matrix(-1 0 0 1 1184 453)",
    fill: "url(#paint42_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 28,
    transform: "matrix(-1 0 0 1 1110 466)",
    fill: "url(#paint43_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    transform: "matrix(-1 0 0 1 1415 458)",
    fill: "url(#paint44_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 467.603C69.5 462.652 -22 470.079 -90 477.505V837H1459V477.505C1044.5 469.769 1079.5 499.475 720.5 499.475C361.5 499.475 292.5 472.554 181 467.603Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 684.5,
    cy: 854.5,
    rx: 1525.5,
    ry: 284.5,
    fill: "url(#paint45_radial_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172 643.397C60.5 648.348 -31 640.921 -99 633.495V532H1450V633.495C1035.5 641.231 1070.5 611.525 711.5 611.525C352.5 611.525 283.5 638.446 172 643.397Z",
    fill: "url(#paint46_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1433.27 870.298H1472.77C1472.77 914.298 1468.97 1000.3 1453.77 992.298C1434.77 982.298 1433.27 979.798 1410.27 980.798C1387.27 981.798 1395.27 964.798 1390.27 970.798C1385.27 976.798 1372.27 969.798 1350.77 964.798C1329.27 959.798 1331.77 955.798 1310.77 948.798C1289.77 941.798 1283.27 943.798 1268.77 943.798H1238.27C1232.77 943.798 1225.27 948.798 1207.77 943.798C1190.27 938.798 1197.77 933.798 1197.27 927.798C1196.77 921.798 1185.77 915.798 1174.77 915.798C1163.77 915.798 1128.77 916.298 1110.77 915.798C1092.77 915.298 1090.77 905.798 1085.27 902.298C1079.77 898.798 1067.27 898.298 1030.77 893.298C994.269 888.298 1025.77 878.798 1030.77 878.798H1076.27C1106.27 878.798 1106.77 885.298 1116.27 893.298C1125.77 901.298 1133.77 893.298 1147.77 893.298C1161.77 893.298 1160.27 885.298 1165.77 878.798C1171.27 872.298 1191.27 885.298 1225.27 885.298C1259.27 885.298 1241.27 898.298 1276.27 898.298C1311.27 898.298 1365.77 904.298 1346.77 893.298C1327.77 882.298 1350.27 878.798 1372.27 885.298C1394.27 891.798 1388.77 884.298 1401.77 878.798C1414.77 873.298 1423.27 870.298 1433.27 870.298Z",
    fill: "#66A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M268.769 799.52H328.269C329.936 800.52 334.369 801.92 338.769 799.52C344.269 796.52 363.269 804.02 404.769 810.02C437.969 814.82 393.602 821.02 367.269 823.52C364.602 825.187 357.869 828.52 352.269 828.52C345.269 828.52 328.269 822.52 311.769 823.52C298.569 824.32 296.602 827.187 297.269 828.52H268.769H234.769C219.269 828.52 218.269 837.52 209.769 855.52C210.769 866.02 187.269 861.52 178.769 861.52C170.269 861.52 156.269 853.02 143.769 845.02C131.269 837.02 137.769 844.02 120.269 845.02C106.269 845.82 109.102 856.353 112.269 861.52C109.436 861.52 102.169 863.12 95.769 869.52C87.769 877.52 57.269 874.17 45.269 874.17C33.269 874.17 40.769 882.17 45.269 888.67C49.769 895.17 28.769 893.67 21.269 893.67C15.269 893.67 2.43561 886.003 -3.23105 882.17C-6.06439 867.17 -12.131 821.62 -13.731 810.02C-15.731 795.52 -6.23105 799.52 3.76895 799.52H47.269C64.769 799.52 68.769 799.52 83.269 790.52C97.769 781.52 132.769 799.52 143.769 799.52H187.269C209.769 799.52 203.769 799.52 218.269 790.52C232.769 781.52 251.269 799.52 268.769 799.52Z",
    fill: "#66A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M719.392 786C705.204 786 701.219 782.497 701 780.745C701.16 780.104 701.853 778.105 702.789 775.405C703.812 772.453 705.126 768.664 706.35 764.898C698.809 759.915 679.053 746.595 678.635 743.535C678.181 740.21 695.405 717.224 699.592 711.694C694.489 701.081 697.971 683.982 701.082 668.702C702.267 662.885 703.397 657.331 703.98 652.5C704.625 647.154 705.155 640.924 705.708 634.431C707.744 610.503 710.085 583 719.591 583C728.926 583 731.652 614.377 733.569 636.451C734.134 642.955 734.629 648.652 735.202 652.5C735.591 655.11 736.355 658.572 737.235 662.559C738.068 666.331 739.004 670.575 739.825 675.015C741.894 663.065 742.16 652.806 741.859 642.991C741.697 637.72 747.803 638.187 748.131 643.469C749.137 674.882 745.3 694.429 740.887 705.827C738.638 715.259 732.616 722 719.591 722C713.845 722 709.45 720.891 706.133 718.925L688.441 742.201L708.605 757.52C708.982 756.165 709.302 754.91 709.539 753.814C709.539 753.814 710.295 753.598 711.544 753.341C708.768 750.406 707 745.968 707 741C707 732.163 712.596 725 719.5 725C726.403 725 732 732.163 732 741C732 745.989 730.216 750.444 727.42 753.378C728.561 753.618 729.245 753.814 729.245 753.814L737.127 780.745C737.127 782.497 733.58 786 719.392 786Z",
    fill: "url(#paint47_linear_497_4581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.132 457.531C749.63 410.749 740.387 390.284 734.494 383.86C730.765 382.882 728.507 387.52 729.588 390.315C741.007 419.827 742.421 439.692 741.859 458.009C741.697 463.28 747.804 462.813 748.132 457.531Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.5,
    cy: 360,
    rx: 12.5,
    ry: 16,
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.392 315C705.204 315 701.219 318.503 701 320.255C701.525 322.357 707.788 339.085 709.539 347.186C709.539 347.186 714.137 348.5 719.392 348.5C724.647 348.5 729.245 347.186 729.245 347.186L737.127 320.255C737.127 318.503 733.58 315 719.392 315Z",
    fill: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.441 358.799L713.468 339.786C713.468 339.786 715.465 337.586 713.575 335.309C711.686 333.033 709.234 334.212 709.234 334.212C709.234 334.212 679.152 353.681 678.635 357.465C678.118 361.249 700.5 390.5 700.5 390.5L707.202 383.482L688.441 358.799Z",
    fill: "#F5B370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.202 448.5C732.685 465.405 731.677 518 719.592 518C707.506 518 707.002 473.545 703.981 448.5C700.959 423.455 683.212 379 719.592 379C755.971 379 737.72 431.595 735.202 448.5Z",
    fill: "#BF660D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.392,
    cy: 320.256,
    rx: 16.4216,
    ry: 3.94118,
    fill: "url(#paint48_radial_497_4581)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_497_4581",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_497_4581",
    x1: 684.396,
    y1: 318.963,
    x2: 684.396,
    y2: 463.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_497_4581",
    x1: 469.372,
    y1: 482.5,
    x2: 469.372,
    y2: 495.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_497_4581",
    x1: 968.269,
    y1: 482.5,
    x2: 968.269,
    y2: 495.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_497_4581",
    x1: 447.372,
    y1: 476.5,
    x2: 447.372,
    y2: 489.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_497_4581",
    x1: 990.269,
    y1: 476.5,
    x2: 990.269,
    y2: 489.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_497_4581",
    x1: 430.372,
    y1: 480.5,
    x2: 430.372,
    y2: 493.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_497_4581",
    x1: 1007.27,
    y1: 480.5,
    x2: 1007.27,
    y2: 493.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_497_4581",
    x1: 409.372,
    y1: 474.5,
    x2: 409.372,
    y2: 487.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_497_4581",
    x1: 1028.27,
    y1: 474.5,
    x2: 1028.27,
    y2: 487.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_497_4581",
    x1: 389.372,
    y1: 477.5,
    x2: 389.372,
    y2: 490.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_497_4581",
    x1: 1048.27,
    y1: 477.5,
    x2: 1048.27,
    y2: 490.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_497_4581",
    x1: 647,
    y1: 462.5,
    x2: 647,
    y2: 503.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(625.967 482.905) rotate(-91.1109) scale(9.73197 40.5499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.967 482.905) rotate(-91.1109) scale(9.73197 40.5499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_497_4581",
    x1: 815.969,
    y1: 456.5,
    x2: 815.969,
    y2: 511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.21894 7.37757) rotate(-90) scale(8.48421 35.3509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(523.19 484.008) rotate(-91.1109) scale(5.84906 24.3711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_497_4581",
    x1: 526.355,
    y1: 487.5,
    x2: 526.355,
    y2: 497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.36584 4.29408) rotate(-91.1109) scale(6.5227 27.1779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_497_4581",
    x1: 891.876,
    y1: 485.024,
    x2: 891.876,
    y2: 495.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_497_4581",
    x1: 573.253,
    y1: 482.129,
    x2: 573.253,
    y2: 507.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF660D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.11328 4.89223) rotate(-90) scale(5.62607 23.4419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF660D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_497_4581",
    x1: 1243.07,
    y1: 34,
    x2: 1243.07,
    y2: 187.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_497_4581",
    x1: 201.311,
    y1: 133,
    x2: 201.311,
    y2: 265.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_497_4581",
    x1: 116,
    y1: 428,
    x2: 116,
    y2: 464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_497_4581",
    x1: 36,
    y1: 435,
    x2: 36,
    y2: 465.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_497_4581",
    x1: 193,
    y1: 438,
    x2: 193,
    y2: 473.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_497_4581",
    x1: 341,
    y1: 450,
    x2: 341,
    y2: 488.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_497_4581",
    x1: 267,
    y1: 428,
    x2: 267,
    y2: 477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_497_4581",
    x1: 115.5,
    y1: 438,
    x2: 115.5,
    y2: 473.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_497_4581",
    x1: 193.5,
    y1: 446,
    x2: 193.5,
    y2: 473.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_497_4581",
    x1: 267.5,
    y1: 441,
    x2: 267.5,
    y2: 481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_497_4581",
    x1: 341.5,
    y1: 462,
    x2: 341.5,
    y2: 485.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_497_4581",
    x1: 36.5,
    y1: 446,
    x2: 36.5,
    y2: 479.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_497_4581",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_497_4581",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 30.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_497_4581",
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_497_4581",
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_497_4581",
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8CCA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8CCA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_497_4581",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_497_4581",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_497_4581",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_497_4581",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_497_4581",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(684 1312) rotate(-90) scale(617.531 3311.23)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_497_4581",
    x1: 613.5,
    y1: 561.5,
    x2: 613.5,
    y2: 647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_497_4581",
    x1: 713.448,
    y1: 786,
    x2: 713.448,
    y2: 616.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_497_4581",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(719.387 329.452) rotate(-91.1109) scale(19.9555 83.1477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE6CF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_4581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater2020);
export default __webpack_public_path__ + "static/media/water2020.ae9bb2b4cfd28ee1f1dee2562cfef697.svg";
export { ForwardRef as ReactComponent };